import { PeriodSwitcher } from "@nymbl/nos2-rules";
import { addMonths, type MonthKey, monthLabel, monthSteps } from "@/lib/month/month";

interface MonthSwitcherProps {
  month: MonthKey;
  /** The viewer's current month; "This month" is disabled while it is shown. */
  current: MonthKey;
  /** The person's PersonPeriod range; null while unknown (the arrows stay put). */
  min: MonthKey | null;
  max: MonthKey | null;
  onChange: (month: MonthKey) => void;
  /** Names a second switcher on the page (see PeriodSwitcher). */
  scope?: string;
}

export function MonthSwitcher({ month, current, min, max, onChange, scope }: MonthSwitcherProps) {
  const steps = monthSteps(month, min, max);
  return (
    <PeriodSwitcher
      unit="month"
      label={monthLabel(month)}
      isCurrent={month === current}
      canPrev={steps.prev}
      canNext={steps.next}
      onPrev={() => onChange(addMonths(month, -1))}
      onNext={() => onChange(addMonths(month, 1))}
      onCurrent={() => onChange(current)}
      labelClassName="w-36"
      scope={scope}
    />
  );
}
